import React from 'react'
import './HeaderArea.css'

function HeaderArea({title}) {
    return (
        <div className="headerArea">
            <h2 className="sectionHeader">{title}</h2>
            <select className="seactionReportFilter" name="" id="">
                <option value="">All Time</option>
                <option value="">12 Months</option>
                <option selected value="">30 Days</option>
                <option value="">7 Days</option>
                <option value="">Today</option>
            </select>
        </div>
    )
}

export default HeaderArea
